import { render, staticRenderFns } from "./SubProductMobileRow.vue?vue&type=template&id=b142ab38&scoped=true"
import script from "./SubProductMobileRow.vue?vue&type=script&lang=js"
export * from "./SubProductMobileRow.vue?vue&type=script&lang=js"
import style0 from "./SubProductMobileRow.vue?vue&type=style&index=0&id=b142ab38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b142ab38",
  null
  
)

export default component.exports